import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findNotice () {
    return axios.post(global.EURLATE_MEMBER_DESC + '/notice/findNotice')
  },
  updateNotice (params) {
    return axios.post(global.EURLATE_MEMBER_DESC + '/notice/updateNotice', params)
  },
  insertNotice (params) {
    return axios.post(global.EURLATE_MEMBER_DESC + '/notice/insertNotice', params)
  },
  deleteNotice (params) {
    return axios.post(global.EURLATE_MEMBER_DESC + '/notice/deleteNoticeType', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/mmc/eventNotice.js